import createDataContext from './createDataContext';
import * as actions from './actions/adminActions';
import { reducer, initialState } from './reducers/adminReducer';

export const { Context: AdminContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
